import React from 'react' // eslint-disable-line

import styled from 'styled-components'
import CaretLeft from 'svg/caret-left.svg'
import CaretRight from 'svg/caret-right.svg'
import Rewind from 'svg/rewind.svg'

// Icons
const IconStyle = (props) => `
  height: 35px;
  width: 35px;
  overflow: visible;
  path {
    stoke: #ffffff;
    stroke-width: 2px;
  }
`

export const NextIcon = styled(CaretRight)`
  ${(props) => IconStyle(props)};
`
export const PrevIcon = styled(CaretLeft)`
  ${(props) => IconStyle(props)};
`
export const RewindIcon = styled(Rewind)`
  width: 16px;
  height: 16px;
  overflow: visible;
`
export const Section = styled.section`
  h2 {
    font-size: 22px;
    margin-top: 0;
  }
  p[data-type='sub-head'] {
    margin-top: 3px;
    font-size: 14px;
  }
  &[data-section='recommended-for-you'] {
    margin-top: 25px;
    margin-bottom: 25px;
  }

  &[data-section='recently-viewed'] {
    margin-top: 60px;
    margin-bottom: 25px;

    @media (max-width: 999px) {
      margin-top: 40px;
    }
  }

  [data-type='rec-for-you-title'] {
    margin-bottom: 10px;
    font-size: 21px;
  }
  [data-type='rec-for-you-sub-title'] {
    margin-bottom: 10px;
    margin-top: 0;
    font-size: 12px;
    color: #666666;
  }
  [data-type='controls'] {
    width: 100%;
    position: relative;
    button {
      cursor: pointer;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 75px;
      background: transparent;
      border: none;
      &:focus {
        outline: none;
      }
      &[data-action='previous'] {
        left: -50px;
      }
      &[data-action='next'] {
        right: -50px;
      }

      &[data-action='restart'] {
        right: 0;
        top: -30px;
        span {
          font-size: 12px;
          font-weight: bold;
          color: #333333;
          margin: 2px 0 0 5px;
        }
      }

      @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        display: none;
      }
    }
  }

  [data-type='carousel'] {
    display: flex;
    width: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      overflow-x: auto;
    }
  }

  ul {
    display: block;
    width: 100%;
    min-height: 300px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
    list-style: outside none none;
    margin: 0px;
    padding: 0px;
    white-space: nowrap;
    transform: translate3d(0px, 0px, 0px);
    transition: 0.2s ease transform;
    will-change: transform;
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      min-height: 280px;
    }
  }

  [parent-data-section='visually-similar'] {
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      min-height: 320px;
    }
  }

  li {
    display: inline-flex;
    justify-content: center;
    align-items: flex-start;
    width: 176px;
    height: 100%;
    vertical-align: top;
    list-style: outside none none;
    margin: 0px;
    padding: 0px;
    overflow: hidden;
    &:not(:last-child) {
      margin-right: 45px;
    }
    [data-type='artwork'] {
      width: 176px;
    }
    img {
      width: 176px;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      width: 160px;
      [data-type='artwork'],
      img {
        width: 160px;
      }
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  a[data-type='see-more'] {
    width: 176px;
    height: 176px;
    background: #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    color: #333333;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      width: 160px;
      height: 160px;
    }
  }
`
